import { render } from "./SubscriptionStatusMessage.vue?vue&type=template&id=3a55c4a2&scoped=true&ts=true"
import script from "./SubscriptionStatusMessage.vue?vue&type=script&lang=ts"
export * from "./SubscriptionStatusMessage.vue?vue&type=script&lang=ts"

import "./SubscriptionStatusMessage.vue?vue&type=style&index=0&id=3a55c4a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a55c4a2"]])

export default __exports__